var BrandArray = new Array("1|HTP America","2|AHP", "3|AMICO POWER", "4|CORNWELL", "5|Eastwood", "6|ESAB", "7|Everlast","8|Fronius", "9|Hobart", "10|LINCOLN", "11|Longevity", "12|LOTOS", 
                           "13|Miller", "14|Primeweld", "15|Snap-On", "16|Thermal Arc", "17|Tweco", "18|Vulcan");//TIG Welder Models

var ModelArray1 = new Array("1|Invertig 221 Air-Cooled",
"2|Invertig 313/301 Air-Cooled",
"3| Invertig 313/301 Water-Cooled",
"4|Invertig 400 Air-Cooled",
"5|Invertig 400 Water-Cooled",
"6|Inverarc 200 TLP Air-Cooled",                        
"7|Invertig 130 DCHF Air-Cooled",
"8|Invertig 130 DCL Air-Cooled",
"9|Invertig 131 DCHF Air-Cooled",
"10|Invertig 131 DCL Air-Cooled",
"11|Invertig 160DC Air-Cooled",
"12|Invertig 201 Air-Cooled",
"13|Invertig 201 Water-Cooled",
"14|Invertig 221 Water-Cooled",
"15|Pro Pulse 220 MTS Air-Cooled",
"16|Pro Pulse 300 Air-Cooled",
"17|Pro Pulse 300 Water-Cooled");//HTP-America

var ModelArray2 = new Array("1|2013 AlphaTIG 200DX Air-Cooled",
"2|2014 AlphaTIG 200X Air-Cooled",
"3|2015 AlphaTIG 200X Air-Cooled",
"4|2015 AlphaTIG 200X Water-Cooled",
"5|2016 AlphaTIG 200X Air-Cooled",
"6|2016 AlphaTIG 200X Water-Cooled",
"7|2017 AlphaTIG 200X Air-Cooled",
"8|2017 AlphaTIG 200X Water-Cooled",
"9|2018 AlphaTIG 200X Air-Cooled",
"10|2018 AlphaTIG 200X Water-Cooled",
"11|2019 AlphaTIG 201XD Air-Cooled",
"12|2019 AlphaTIG 201XD Water-Cooled");//AHP

var ModelArray3 = new Array("1|TIG-185 Air-Cooled",
"2|TIG-185 Water-Cooled",
"3|TIG-205 Air-Cooled",
"4|TIG-205 Water-Cooled");//AMICO POWER

var ModelArray4 = new Array("1|MMWTIG241I Air-Cooled",
"2|MMWTIG241I Water-Cooled");//CRONWELL

var ModelArray5 = new Array("1|TIG 200 Air-Cooled",
"2|TIG 200 DC Air-Cooled",
"3|TIG 200 Digital Air-Cooled");//Eastwood

var ModelArray6 = new Array("1|Caddy Tig 2200i Air-Cooled",
"2|Caddy Tig 2200i Water-Cooled",
"3|ET 220I Air-Cooled",
"4|ET 220I Water-Cooled",
"5|FABRICATOR 141I Air-Cooled",
"6|MINIARC 161LTS Air-Cooled",
"7|REBEL EMP 205IC Air-Cooled",
"8|REBEL EMP 215IC Air-Cooled",
"9|REBEL EMP 235IC Air-Cooled",
"10|ROGUE ES 130I PRO Air-Cooled",
"11|ROGUE 180I PRO Air-Cooled",
"12|ROGUE ET 200I PRO Air-Cooled");//ESAB

var ModelArray7 = new Array("1|Power i-TIG 200 Air-Cooled",
"2|Power i-TIG 200 Water-Cooled",
"3|PowerARC 140ST Air-Cooled",
"4|PowerARC 140STH Air-Cooled",
"5|PowerARC 280STH Air-Cooled",
"6|PowerARC 280STH Water-Cooled",
"7|PowerMTS 211Si Air-Cooled",
"8|PowerMTS 211Si Water-Cooled",
"9|PowerMTS 221STi Air-Cooled",
"10|PowerMTS 221STi Water-Cooled",
"11|PowerPro 164 Air-Cooled",
"12|PowerPro 164 Water-Cooled",
"13|PowerPro 205S Air-Cooled",
"14|PowerPro 205S Water-Cooled",
"15|PowerPro 256S Air-Cooled",
"16|PowerPro 256S Water-Cooled",
"17|PowerPro 256Si Air-Cooled",
"18|PowerPro 256Si Water-Cooled",
"19|PowerTIG 200 DV Air-Cooled",
"20|PowerTIG 200 DV Water-Cooled",
"21|PowerTIG 200DX Air-Cooled",
"22|PowerTIG 200DX Water-Cooled",
"23|PowerTIG 210EXT Air-Cooled",
"24|PowerTIG 210EXT Water-Cooled",
"25|PowerTIG 225LX Air-Cooled",
"26|PowerTIG 225LX Water-Cooled",
"27|PowerTIG 250EX Air-Cooled",
"28|PowerTIG 250EX Water-Cooled",
"29|PowerTIG 255EXT Air-Cooled",
"30|PowerTIG 255EXT Water-Cooled",
"31|PowerTIG 315LX Air-Cooled",
"32|PowerTIG 315LX Water-Cooled",
"33|PowerTIG 325EXT Air-Cooled",
"34|PowerTIG 325EXT Water-Cooled");//Everlast

var ModelArray8 = new Array("1|Magicwave 230i");//Fronius

var ModelArray9 = new Array("1|150 STI Air-Cooled",
"2|EZ-TIG 165 Air-Cooled",
"3|TIGMate Air-Cooled",
"4|TIGMate Water-Cooled");//Hobart

var ModelArray10 = new Array("1|Aspect 375 Air-Cooled",
"2|Aspect 375 Water-Cooled",
"3|Idealarc 250 Water-Cooled",
"4|Invertec V160-T Air-Cooled",
"5|Invertec V160-T Water-Cooled",
"6|Invertec V200-T Air-Cooled",
"7|Invertec V200-T Water-Cooled",
"8|Invertec V205-T Air-Cooled",
"9|Invertec V205-T Water-Cooled",
"10|Invertec V310-T Air-Cooled",
"11|Invertec V310-T Water-Cooled",
"12|Invertec V311-T Air-Cooled",
"13|Invertec V311-T Water-Cooled",
"14|POWER MIG 210 MP Air-Cooled",
"15|Precision TIG 185 Air-Cooled",
"16|Precision TIG 185 Water-Cooled",
"17|Precision TIG 225 Air-Cooled",
"18|Precision TIG 225 Water-Cooled",
"19|Precision TIG 275 Water-Cooled",
"20|Precision TIG 375 Water-Cooled",
"21|Speedtec 200C Air-Cooled",
"22|Square Wave 175 Air-Cooled",
"23|Square Wave 175 Water-Cooled",
"24|Square Wave 200 Air-Cooled",
"25|Square Wave 200 Water-Cooled",
"26|Square Wave 255 Water-Cooled",
"27|Square Wave 275 Air-Cooled",
"28|Square Wave 275 Water-Cooled",
"29|Square Wave 350 Water-Cooled",
"30|Square Wave 355 Water-Cooled");//LINCOLN

var ModelArray11 = new Array(
"1|MicroTIG 200 Digital Air-Cooled",
"2|TIGWELD 160SX Air-Cooled",
"3|TIGWELD 200D Air-Cooled",
"4|TIGWELD 200DX Air-Cooled",
"5|TIGWELD 200DX Water-Cooled",
"6|TIGWELD 200EX Air-Cooled",
"7|TIGWELD 200EX Water-Cooled",
"8|TIGWELD 200SX Newer Model Air-Cooled",
"9|TIGWELD 200SX Older Model Air-Cooled",
"10|TIGWELD 250EX Air-Cooled",
"11|TIGWELD 250EX Water-Cooled",
"12|TIGWELD 315 Air-Cooled",
"13|TIGWELD 315 Water-Cooled",
"14|WeldAll 200PI Air-Cooled",
"15|WeldAll 200PI Water-Cooled",
"16|Weldpro LS-160P Air-Cooled");//Longevity

var ModelArray12 = new Array("1|CT520D Air-Cooled",
"2|TIG 299 Air-Cooled");//LOTOS

var ModelArray13 = new Array("1|CST 250 Air-Cooled",
"2|CST 280 Air-Cooled",
"3|Diversion 165 Air-Cooled",
"4|Diversion 180 Air-Cooled",
"5|Dynasty 200 DX Air-Cooled",
"6|Dynasty 200 DX Water-Cooled",
"7|Dynasty 280 DX Air-Cooled",
"8|Dynasty 280 DX Water-Cooled",
"9|Dynasty 300 Series Air-Cooled",
"10|Dynasty 300 Series Water-Cooled",
"11|Dynasty 350 Air-Cooled",
"12|Dynasty 350 Water-Cooled",
"13|Econotig Air-Cooled",
"14|Econotig Water-Cooled",
"15|Maxstar 140 Air-Cooled",
"16|Maxstar 150 Air-Cooled",
"17|Maxstar 150 S Air-Cooled",
"18|Maxstar 150 STH Air-Cooled",
"19|Maxstar 150 STL Air-Cooled",
"20|Maxstar 152 Air-Cooled",
"21|Maxstar 152 Water-Cooled",
"22|Maxstar 200 Air-Cooled",
"23|Maxstar 200 Water-Cooled",
"24|Maxstar 300 Series Air-Cooled",
"25|Maxstar 300 Series Water-Cooled",
"26|Maxstar 350 Air-Cooled",
"27|Maxstar 350 Water-Cooled",
"28|Multimatic 200 Air-Cooled",
"29|Multimatic 215 Air-Cooled",
"30|Multimatic 220 Air-Cooled",
"31|Syncrowave 180 SD Air-Cooled",
"32|Syncrowave 180 SD Water-Cooled",
"33|Syncrowave 200 Air-Cooled",
"34|Syncrowave 200 Water-Cooled",
"35|Syncrowave 210 Air-Cooled",
"36|Syncrowave 210 Water-Cooled",
"37|Syncrowave 250 Water-Cooled",
"38|Syncrowave 250 DX SN LE386757 and Down Water-Cooled",
"39|Syncrowave 250 DX SN LE386758 and Up Air-Cooled",
"40|Syncrowave 250 DX SN LE386758 and Up Water-Cooled",
"41|Syncrowave 350 Water-Cooled",
"42|Syncrowave 350 LX Air-Cooled",
"43|Syncrowave 350 LX Water-Cooled",
"44|Thunderbolt Air-Cooled",
"45|XMT 304 Air-Cooled");//Miller

var ModelArray14 = new Array("1|CT520D Air-Cooled",
"2|225X with 25 Dinse Power Connection Air-Cooled",
"3|225X with 35 Dinse Power Connection Air-Cooled",
"4|225X with 35 Dinse Power Connection Water-Cooled");//Primeweld

var ModelArray15 = new Array("1|TIG 150i Air-Cooled",
"2|TIG 150i Water-Cooled");//Snap-On

var ModelArray16 = new Array("1|185 Air-Cooled",
"2|185 Water-Cooled",
"3|186 Air-Cooled",
"4|186 Water-Cooled",
"5|130S Air-Cooled",
"6|161 STL Air-Cooled",
"7|161 STL Water-Cooled",
"8|Fabricator 141i Air-Cooled",
"9|Fabricator 141i Water-Cooled",
"10|Fabricator 181i Air-Cooled",
"11|Fabricator 211i Air-Cooled",
"12|Fabricator 252i Air-Cooled",
"13|Fabricator 252i Water-Cooled",
"14|LM-200 ARCMASTER Air-Cooled",
"15|LM-200 ARCMASTER Water-Cooled",
"16|PRO-WAVE 300 TSW Air-Cooled",
"17|PRO-WAVE 300 TSW Water-Cooled");//Thermal Arc

var ModelArray17 = new Array("1|186 Air-Cooled",
"2|186 Water-Cooled",
"3|Arcmaster 141 Air-Cooled",
"4|Arcmaster 141 Water-Cooled",
"5|Fabricator 141i Air-Cooled");//Tweco

var ModelArray18 = new Array("1|OmniPro 220 Air-Cooled",
"2|ProTIG 165 Air-Cooled",
"3|ProTIG 200 Air-Cooled",
"4|ProTIG 200 Water-Cooled",
"5|ProTIG 205 Air-Cooled",
"6|ProTIG 205 Water-Cooled");//Vulcan

var ModelArray19 = new Array("1|FP-120 1444-0304 HTP Replacement",
"2|FP-125 1444-0324 HTP Replacement",
"3|FP-125 1444-0324 OEM",
"4|FP-130 1444-0306 HTP Replacement",
"5|FP-135 1444-0326 HTP Replacement",
"6|FP-135 1444-0326 OEM",
"7|FP-160 1444-0308 HTP Replacement",
"8|FP-165 1444-0328 HTP Replacement",
"9|FP-165 1444-0328 OEM",
"10|FP-200 1444-0310 HTP Replacement",
"11|FP-260 1444-0312 HTP Replacement",
"12|MST 140i HTP Replacement",
"13|MST 180i HTP Replacement",
"14|MST 220i HTP Replacement");//Firepower Models - MIG

var ModelArray20 = new Array("1|MIG 210 HTP Replacement",
"2|MIG 210 OEM");//Forney Models - MIG

var ModelArray21 = new Array("1|MIG 1000 HTP Replacement",
"2|MIG 160 HTP Replacement",
"3|MIG 160A HTP Replacement",
"4|MIG 2000 HTP Replacement");//Henning Hanson Models - MIG

var ModelArray22 = new Array("1|BETA-MIG 170 HTP Flex",
"2|BETA-MIG 170 HTP Replacement",
"3|BETA-MIG 1800 HTP Flex",
"4|BETA-MIG 1800 HTP Replacement",
"5|BETA-MIG 1800 OEM",
"6|BETA-MIG 200 HTP Replacement",
"7|BETA-MIG 250 HTP Replacement",
"8|BETA-MIG 251 HTP Replacement",
"9|BETA-MIG 2510 HTP Flex",
"10|BETA-MIG 2510 HTP Replacement",
"11|BETA-MIG 2510 OEM",
"12|Handler 120 HTP Flex",
"13|Handler 120 HTP Replacement",
"14|Handler 130XL HTP Flex",
"15|Handler 130XL HTP Replacement",
"16|Handler 135 HTP Flex",
"17|Handler 135 HTP Replacement",
"18|Handler 135 OEM",
"19|Handler 140 HTP Flex",
"20|Handler 140 HTP Replacement",
"21|Handler 140 OEM",
"22|Handler 150 HTP Flex",
"23|Handler 150 HTP Replacement",
"24|Handler 175 HTP Flex",
"25|Handler 175 HTP Replacement",
"26|Handler 175 OEM",
"27|Handler 180 HTP Flex",
"28|Handler 180 HTP Replacement",
"29|Handler 180 OEM",
"30|Handler 187 HTP Flex",
"31|Handler 187 HTP Replacement",
"32|Handler 187 OEM",
"33|Handler 190 HTP Replacement",
"34|Handler 190 HTP Flex",
"35|Handler 190 OEM",
"36|Handler 210 HTP Replacement",
"37|Handler 210 HTP Flex",
"38|Handler 210 OEM",
"39|Handler 210MVP",
"40|Handler 210MVP HTP Flex",
"41|Handler 210MVP OEM",
"42|Handler HTP Flex",
"43|Handler HTP Replacement",
"44|IronMan 210 HTP Flex",
"45|IronMan 210 HTP Replacement",
"46|IronMan 210 OEM",
"47|IronMan 230 HTP Flex",
"48|IronMan 230 HTP Replacement",
"49|IronMan 230 OEM",
"50|IronMan 250 HTP Flex",
"51|IronMan 250 HTP Replacement",
"52|IronMan 250 OEM",
"53|IronMan 275 HTP Flex",
"54|IronMan 275 HTP Replacement",
"55|IronMan 275 OEM",
"56|MIG-MAN HTP Flex",
"57|MIG-MAN HTP Replacement",
"58|Trek 180 HTP Flex",
"59|Trek 180 HTP Replacement",
"60|Trek 180 OEM");//Hobart Models - MIG

var ModelArray23 = new Array("1|Auto MIG",
"2|Econo MIG",
"3|Maxi MIG",
"4|MIG 110",
"5|MIG 130",
"6|MIG 140",
"7|MIG 160",
"8|MIG 1600",
"9|MIG 160DV",
"10|MIG 200",
"11|MIG 200i",
"12|MIG 240",
"13|MIG 240 Flex",
"14|MIG 2400",
"15|MIG 2400 Flex",
"16|MIG 2400-24-ST",
"17|MIG 2400-24-ST Flex",
"18|Mini MIG",
"19|Pro Pulse 200 15 Series MIG Gun",
"20|Pro Pulse 200 24 Series MIG Gun",
"21|Pro Pulse 200 26 Series MIG Gun",
"22|Pro Pulse 220 MTS 15 Series MIG Gun",
"23|Pro Pulse 220 MTS 24 Series MIG Gun",
"24|Pro Pulse 220 MTS 26 Series MIG Gun",
"25|Pro Pulse 300 24 Series MIG Gun",
"26|Pro Pulse 300 26 Series MIG Gun",
"27|Pro Pulse 300 36 Series MIG Gun",
"28|Versa MIG");//HTP Models - MIG

var ModelArray24 = new Array("1|Easy-Core 125 HTP Flex",
"2|Easy-Core 125 HTP Replacement",
"3|Easy-Core 125 OEM",
"4|EasyMIG 140 HTP Flex",
"5|EasyMIG 140 HTP Replacement",
"6|EasyMIG 140 OEM",
"7|EasyMIG 180 HTP Flex",
"8|EasyMIG 180 HTP Replacement",
"9|EasyMIG 180 OEM",
"10|Handymig 170i HTP Flex",
"11|Handymig 170i HTP Replacement",
"12|Handymig 170i OEM",
"13|LN25 HTP Replacement",
"14|LN4 HTP Replacement",
"15|LN7 HTP Replacement",
"16|MIG-PAK 10 HTP Flex",
"17|MIG-PAK 10 HTP Replacement",
"18|MIG-PAK 10 OEM",
"19|MIG-PAK 140 HTP Flex",
"20|MIG-PAK 140 HTP Replacement",
"21|MIG-PAK 140 OEM",
"22|MIG-PAK 15 HTP Flex",
"23|MIG-PAK 15 HTP Replacement",
"24|MIG-PAK 15 OEM",
"25|MIG-PAK 180 HTP Flex",
"26|MIG-PAK 180 HTP Replacement",
"27|MIG-PAK 180 OEM",
"28|POWER MIG 140C HTP Flex",
"29|POWER MIG 140C HTP Replacement",
"30|POWER MIG 140C OEM",
"31|POWER MIG 140T HTP Flex",
"32|POWER MIG 140T HTP Replacement",
"33|POWER MIG 140T OEM",
"34|POWER MIG 180 DUAL HTP Flex",
"35|POWER MIG 180 DUAL HTP Replacement",
"36|POWER MIG 180 DUAL OEM",
"37|POWER MIG 180C HTP Flex",
"38|POWER MIG 180C HTP Replacement",
"39|POWER MIG 180C OEM",
"40|POWER MIG 180T HTP Flex",
"41|POWER MIG 180T HTP Replacement",
"42|POWER MIG 180T OEM",
"43|POWER MIG 200 HTP Flex",
"44|POWER MIG 200 HTP Replacement",
"45|POWER MIG 200 OEM",
"46|POWER MIG 210 MP HTP Flex",
"47|POWER MIG 210 MP HTP Replacement",
"48|POWER MIG 210 MP OEM",
"49|POWER MIG 215 HTP Flex",
"50|POWER MIG 215 HTP Replacement",
"51|POWER MIG 215 OEM",
"52|POWER MIG 216 HTP Flex",
"53|POWER MIG 216 HTP Replacement",
"54|POWER MIG 216 OEM",
"55|POWER MIG 255 HTP Flex",
"56|POWER MIG 255 HTP Replacement",
"57|POWER MIG 255 OEM",
"58|POWER MIG 255XT HTP Flex",
"59|POWER MIG 255XT HTP Replacement",
"60|POWER MIG 255XT OEM",
"61|POWER MIG 256 HTP Flex",
"62|POWER MIG 256 HTP Replacement",
"63|POWER MIG 256 OEM",
"64|POWER MIG 350MP HTP Flex",
"65|POWER MIG 350MP HTP Replacement",
"66|POWER MIG 350MP OEM",
"67|PRO 100 HTP Flex",
"68|PRO 100 HTP Replacement",
"69|PRO 100 OEM",
"70|PRO 155 HTP Flex",
"71|PRO 155 HTP Replacement",
"72|PRO 155 OEM",
"73|PRO-CORE 100 HTP Flex",
"74|PRO-CORE 100 HTP Replacement",
"75|PRO-CORE 100 OEM",
"76|PRO-CORE 125 HTP Flex",
"77|PRO-CORE 125 HTP Replacement",
"78|PRO-CORE 125 OEM",
"79|PRO-MIG 135 HTP Flex",
"80|PRO-MIG 135 HTP Replacement",
"81|PRO-MIG 135 OEM",
"82|PRO-MIG 140 CODE 11128 HTP Flex",
"83|PRO-MIG 140 CODE 11128 HTP Replacement",
"84|PRO-MIG 140 CODE 11128 OEM",
"85|PRO-MIG 140 EXCEPT CODE 11128 HTP Flex",
"86|PRO-MIG 140 EXCEPT CODE 11128 HTP Replacement",
"87|PRO-MIG 140 EXCEPT CODE 11128 OEM",
"88|PRO-MIG 175 HTP Flex",
"89|PRO-MIG 175 HTP Replacement",
"90|PRO-MIG 175 OEM",
"91|PRO-MIG 180 HTP Flex",
"92|PRO-MIG 180 HTP Replacement",
"93|PRO-MIG 180 OEM",
"94|PRO-MIG 255C CODE 11192 HTP Flex",
"95|PRO-MIG 255C CODE 11192 HTP Replacement",
"96|PRO-MIG 255C CODE 11192 OEM",
"97|SP-100 HTP Flex",
"98|SP-100 HTP Replacement",
"99|SP-100 OEM",
"100|SP-100T HTP Flex",
"101|SP-100T HTP Replacement",
"102|SP-100T OEM",
"103|SP-125 PLUS HTP Flex",
"104|SP-125 PLUS HTP Replacement",
"105|SP-125 PLUS OEM",
"106|SP-130T HTP Flex",
"107|SP-130T HTP Replacement",
"108|SP-130T OEM",
"109|SP-135 PLUS HTP Flex",
"110|SP-135 PLUS HTP Replacement",
"111|SP-135 PLUS OEM",
"112|SP-135T HTP Flex",
"113|SP-135T HTP Replacement",
"114|SP-135T OEM",
"115|SP-140T HTP Flex",
"116|SP-140T HTP Replacement",
"117|SP-140T OEM",
"118|SP-150 HTP Replacement",
"119|SP-155 HTP Flex",
"120|SP-155 HTP Replacement",
"121|SP-155 OEM",
"122|SP-170 HTP Flex",
"123|SP-170 HTP Replacement",
"124|SP-170 OEM",
"125|SP-170T HTP Flex",
"126|SP-170T HTP Replacement",
"127|SP-170T OEM",
"128|SP-175 PLUS HTP Flex",
"129|SP-175 PLUS HTP Replacement",
"130|SP-175 PLUS OEM",
"131|SP-175T HTP Flex",
"132|SP-175T HTP Replacement",
"133|SP-175T OEM",
"134|SP-180T HTP Flex",
"135|SP-180T HTP Replacement",
"136|SP-180T OEM",
"137|SP-200 HTP Replacement",
"138|SP-250 HTP Replacement",
"139|SP-255 HTP Replacement",
"140|SP-85 HTP Flex",
"141|SP-85 HTP Replacement",
"142|SP-85 OEM",
"143|Speedtec 200C HTP Flex",
"144|Speedtec 200C HTP Replacement",
"145|WELDMARK 135 PLUS HTP Flex",
"146|WELDMARK 135 PLUS HTP Replacement",
"147|WELDMARK 135 PLUS OEM",
"148|WELD-PAK 100 HTP Flex",
"149|WELD-PAK 100 HTP Replacement",
"150|WELD-PAK 100 OEM",
"151|WELD-PAK 100HD HTP Flex",
"152|WELD-PAK 100HD HTP Replacement",
"153|WELD-PAK 100HD OEM",
"154|WELD-PAK 125 HTP Flex",
"155|WELD-PAK 125 HTP Replacement",
"156|WELD-PAK 125 OEM",
"157|WELD-PAK 125HD HTP Flex",
"158|WELD-PAK 125HD HTP Replacement",
"159|WELD-PAK 125HD OEM",
"160|WELD-PAK 140HD HTP Flex",
"161|WELD-PAK 140HD HTP Replacement",
"162|WELD-PAK 140HD OEM",
"163|WELD-PAK 155 HTP Flex",
"164|WELD-PAK 155 HTP Replacement",
"165|WELD-PAK 155 OEM",
"166|WELD-PAK 175HD HTP Flex",
"167|WELD-PAK 175HD HTP Replacement",
"168|WELD-PAK 175HD OEM",
"169|WELD-PAK 180HD HTP Flex",
"170|WELD-PAK 180HD HTP Replacement",
"171|WELD-PAK 180HD OEM",
"172|WELD-PAK 3200HD HTP Flex",
"173|WELD-PAK 3200HD HTP Replacement",
"174|WELD-PAK 3200HD OEM",
"175|WELD-PAK 5000HD HTP Flex",
"176|WELD-PAK 5000HD HTP Replacement",
"177|WELD-PAK 5000HD OEM",
"178|WIRE-MATIC 250 HTP Flex",
"179|WIRE-MATIC 250 HTP Replacement",
"180|WIRE-MATIC 250 OEM",
"181|WIRE-MATIC 255 HTP Flex",
"182|WIRE-MATIC 255 HTP Replacement",
"183|WIRE-MATIC 255 OEM",
"184|Work-Pak 125 HTP Flex",
"185|Work-Pak 125 HTP Replacement",
"186|Work-Pak 125 OEM");//LINCOLN Models - MIG

var ModelArray25 = new Array("1|ArcMate 205P HTP Replacement",
"2|MIGWELD 140 HTP Flex",
"3|MIGWELD 140 HTP Replacement",
"4|MIGWELD 140 OEM",
"5|MIGWELD 200S HTP Flex",
"6|MIGWELD 200S HTP Replacement",
"7|MIGWELD 200S OEM",
"8|MIGWELD 250MP HTP Flex",
"9|MIGWELD 250MP HTP Replacement",
"10|MIGWELD 250P HTP Flex",
"11|MIGWELD 250P HTP Replacement",
"12|Pro MTS 200 HTP Replacement",
"13|Pro MTS 200i HTP Replacement",
"14|ProMTS 252i HTP Flex",
"15|ProMTS 252i HTP Replacement");//Longevity Models - MIG

var ModelArray26 = new Array("1|MIG 140 HTP Flex",
"2|MIG 140 HTP Replacement");//LOTOS Models - MIG
 
 var ModelArray27 = new Array("1|MIG 250 HTP Flex",
"2|MIG 250 HTP Replacement Model 1",
"3|MIG 250 HTP Replacement Model 2",
"4|MIGMaster 250 HTP replacement");//L-TEC Models - MIG

 var ModelArray28 = new Array("1|MW130A HTP Replacement",
"2|MW135 HTP Flex",
"3|MW135 HTP Replacement",
"4|MW135X HTP Flex",
"5|MW135X HTP Replacement",
"6|MW135X OEM",
"7|MW140 Plus HTP Flex",
"8|MW140 Plus HTP Replacement",
"9|MW140 Plus OEM",
"10|MW145 HTP Replacement",
"11|MW145A HTP Replacement",
"12|MW145N HTP Replacement",
"13|MW150 HTP Replacement",
"14|MW150K HTP Replacement",
"15|MW165 HTP Replacement",
"16|MW165A HTP Replacement",
"17|MW175 S-N KF975790 & Up HTP Replacement",
"18|MW175 HTP Flex",
"19|MW175 HTP Replacement",
"20|MW175X HTP Flex",
"21|MW175X HTP Replacement",
"22|MW175X OEM",
"23|MW180 Plus HTP Flex",
"24|MW180 Plus HTP Replacement",
"25|MW180 Plus OEM",
"26|MW185 Plus HTP Flex",
"27|MW185 Plus HTP Replacement",
"28|MW185 Plus OEM",
"29|MW185N HTP Replacement",
"30|MW225 HTP Replacement",
"31|MW250 HTP Replacement",
"32|MW250X HTP Flex",
"33|MW250X HTP Replacement",
"34|MW250X OEM",
"35|MW260X HTP Flex",
"36|MW260X HTP Replacement",
"37|MW260X OEM",
"38|MW270 Plus HTP Flex",
"39|MW270 Plus HTP Replacement",
"40|MW270 Plus OEM",
"41|MW275N HTP Replacement",
"42|MW275X HTP Flex",
"43|MW275X HTP Replacement",
"44|MW275X OEM",
"45|WS007K HTP Flex",
"46|WS007K HTP Replacement",
"47|WS007K OEM",
"48|WS1110 HTP Replacement Model 1",
"49|WS1110 HTP Replacement Model 2",
"50|WS117 HTP Flex",
"51|WS117 HTP Replacement",
"52|WS117 OEM",
"53|WS117K HTP Flex",
"54|WS117K HTP Replacement",
"55|WS117K OEM",
"56|WS120 HTP Flex",
"57|WS120 HTP Replacement",
"58|WS120 OEM",
"59|WS1300 MAC MIG HTP Replacement Model 1",
"60|WS1300 MAC MIG HTP Replacement Model 2",
"61|WS225K 117-018 HTP Replacement",
"62|WS225K 117-018 OEM",
"63|WS225K 117-042 HTP Replacement",
"64|WS225K 117-042 OEM");//MAC Tools - MIG

 var ModelArray29 = new Array("1|M02155 HTP Replacement",
"2|M02160 HTP Flex",
"3|M02160 HTP Replacement",
"4|M02160 OEM",
"5|M02170 HTP Replacement",
"6|M02185 HTP Replacement Model 1",
"7|M02185 HTP Replacement Model 2",
"8|M02199  117-089  HTP Replacement",
"9|M02230  117-090  HTP Replacement",
"10|M12175 HTP Flex",
"11|M12175 HTP Replacement",
"12|M12175 OEM",
"13|M12178 HTP Replacement Model 1",
"14|M12178 HTP Replacement Model 2",
"15|M12179 HTP Replacement Model 1",
"16|M12179 HTP Replacement Model 2",
"17|M12180 HTP Replacement Model 1",
"18|M12180 HTP Replacement Model 2",
"19|M12183 HTP Replacement",
"20|M12184 HTP Replacement",
"21|M12190 HTP Replacement",
"22|M12205 HTP Replacement",
"23|M12208 HTP Replacement",
"24|M12209 HTP Replacement",
"25|M12210 HTP Flex",
"26|M12210 HTP Replacement",
"27|M12211 HTP Flex",
"28|M12211 HTP Replacement");//Marquette - MIG

 var ModelArray30 = new Array("1|MG145 HTP Replacement",
"2|MG180 HTP Replacement",
"3|MIG 140 HTP Replacement",
"4|MIG 170 HTP Replacement",
"5|MP140 HTP Flex",
"6|MP140 HTP Replacement",
"7|MP140 OEM",
"8|MP240 HTP Flex",
"9|MP240 HTP Replacement",
"10|MP240 OEM",
"11|WF225 117-018 HTP Flex",
"12|WF225 117-018 HTP Replacement",
"13|WF225 117-018 OEM",
"14|WF225 117-042 HTP Flex",
"15|WF225 117-042 HTP Replacement",
"16|WF225 117-042 OEM",
"17|WFFC 117-055 HTP Flex",
"18|WFFC 117-055 HTP Replacement",
"19|WFFC 117-055 OEM",
"20|WFW1 117-015 HTP Flex",
"21|WFW1 117-015 HTP Replacement",
"22|WFW1 117-015 OEM",
"23|WFW1 117-044 HTP Flex",
"24|WFW1 117-044 HTP Replacement",
"25|WFW1 117-044 OEM",
"26|WFW12179 HTP Replacement Model 1",
"27|WFW12179 HTP Replacement Model 2",
"28|WFW140 117-059 HTP Flex",
"29|WFW140 117-059 HTP Replacement",
"30|WFW140 117-059 OEM",
"31|WFW150 HTP Replacement",
"32|WFW160 117-067 HTP Flex",
"33|WFW160 117-067 HTP Replacement",
"34|WFW160 117-067 OEM",
"35|WFW170 117-087 HTP Replacement",
"36|WFW250 117-062 HTP Flex",
"37|WFW250 117-062 HTP Replacement",
"38|WFW250 117-062 OEM",
"39|WFWM 117-030 HTP Flex",
"40|WFWM 117-030 HTP Replacement",
"41|WFWM 117-030 OEM",
"42|WFWM 117-038 HTP Flex",
"43|WFWM 117-038 HTP Replacement",
"44|WFWM 117-038 OEM",
"45|WFWMDP 117-051 HTP Flex",
"46|WFWMDP 117-051 HTP Replacement",
"47|WFWMDP 117-051 OEM",
"48|WFWT 117-027 HTP Flex",
"49|WFWT 117-027 HTP Replacement",
"50|WFWT 117-027 OEM");//MATCO - MIG

 var ModelArray31 = new Array("1|Cricket HTP Replacement",
"2|Cricket XL HTP Replacement",
"3|Gold Seal 420 HTP Flex",
"4|Gold Seal 420 HTP Replacement",
"5|Gold Seal 420 OEM",
"6|Gold Seal 422 HTP Flex",
"7|Gold Seal 422 HTP Replacement",
"8|Gold Seal 442 HTP Flex",
"9|Gold Seal 442 HTP Replacement",
"10|Millermatic 120 HTP Flex",
"11|Millermatic 120 HTP Replacement",
"12|Millermatic 120 OEM",
"13|Millermatic 125 HTP Flex",
"14|Millermatic 125 HTP Replacement",
"15|Millermatic 125 OEM",
"16|Millermatic 130 HTP Replacement",
"17|Millermatic 130XP HTP Flex",
"18|Millermatic 130XP HTP Replacement",
"19|Millermatic 130XP OEM",
"20|Millermatic 135 HTP Flex",
"21|Millermatic 135 HTP Replacement",
"22|Millermatic 135 OEM",
"23|Millermatic 140 HTP Flex",
"24|Millermatic 140 HTP Replacement",
"25|Millermatic 140 OEM",
"26|Millermatic 140 w-Auto-Set HTP Flex",
"27|Millermatic 140 w-Auto-Set HTP Replacement",
"28|Millermatic 140 w-Auto-Set OEM",
"29|Millermatic 141 HTP Flex",
"30|Millermatic 141 HTP Replacement",
"31|Millermatic 141 OEM",
"32|Millermatic 150 HTP Replacement",
"33|Millermatic 180 HTP Flex",
"34|Millermatic 180 HTP Replacement",
"35|Millermatic 180 OEM",
"36|Millermatic 180 w-Auto-Set HTP Flex",
"37|Millermatic 180 w-Auto-Set HTP Replacement",
"38|Millermatic 180 w-Auto-Set OEM",
"39|Millermatic 185 HTP Flex",
"40|Millermatic 185 HTP Replacement",
"41|Millermatic 185 OEM",
"42|Millermatic 190 HTP Flex",
"43|Millermatic 190 HTP Replacement",
"44|Millermatic 190 OEM",
"45|Millermatic 200 HTP Flex",
"46|Millermatic 200 HTP Replacement",
"47|Millermatic 200 OEM",
"48|Millermatic 210 HTP Flex",
"49|Millermatic 210 HTP Replacement",
"50|Millermatic 210 OEM",
"51|Millermatic 212 HTP Flex",
"52|Millermatic 212 HTP Replacement",
"53|Millermatic 212 OEM",
"54|Millermatic 250 HTP Flex",
"55|Millermatic 250 HTP Replacement",
"56|Millermatic 250 OEM",
"57|Millermatic 250X HTP Flex",
"58|Millermatic 250X HTP Replacment",
"59|Millermatic 250X OEM",
"60|Millermatic 251 HTP Flex",
"61|Millermatic 251 HTP Replacement",
"62|Millermatic 251 OEM",
"63|Millermatic 252 HTP Flex",
"64|Millermatic 252 HTP Replacement",
"65|Millermatic 252 OEM",
"66|Millermatic 35 S-N JA448186 & Up HTP Flex",
"67|Millermatic 35 S-N JA448186 & Up HTP Replacement",
"68|Millermatic 35 S-N JA448186 & Up OEM",
"69|Millermatic 90 HTP Replacement",
"70|Millermatic Challenger 172 HTP Flex",
"71|Millermatic Challenger 172 HTP Replacement",
"72|Millermatic Challenger 172 OEM",
"73|Millermatic Challenger HTP Flex",
"74|Millermatic Challenger HTP Replacement",
"75|Millermatic Challenger OEM",
"76|Millermatic DVI HTP Flex",
"77|Millermatic DVI HTP Replacement",
"78|Millermatic DVI OEM",
"79|Millermatic Passport HTP Flex",
"80|Millermatic Passport HTP Replacement",
"81|Millermatic Passport OEM",
"82|Millermatic Passport Plus HTP Flex",
"83|Millermatic Passport Plus HTP Replacement",
"84|Millermatic Passport Plus OEM",
"85|Millermatic Pulser HTP Flex",
"86|Millermatic Pulser HTP Replacement",
"87|Millermatic Pulser OEM",
"88|Millermatic Vintage HTP Flex",
"89|Millermatic Vintage HTP Replacement",
"90|Millermatic Vintage OEM",
"91|Sidekick HTP Replacement",
"92|Sidekick XL HTP Replacement",
"93|SuitCase 12RC Extreme HTP Flex",
"94|SuitCase 12RC Extreme HTP Replacement",
"95|SuitCase 12RC Extreme OEM",
"96|SuitCase 12VS Extreme HTP Flex",
"97|SuitCase 12VS Extreme HTP Replacement",
"98|SuitCase 12VS Extreme OEM");//Miller - MIG

 var ModelArray32 = new Array("1|83-210 HTP Replacement Model 1",
"2|83-210 HTP Replacement Model 2",
"3|83-310 HTP Replacement",
"4|83-317 HTP Replacement",
"5|83-318 HTP Replacement",
"6|83-319 HTP Replacement ",
"7|83-320 HTP Replacement",
"8|83-327 HTP Replacement",
"9|83-363 HTP Replacement Model 1",
"10|83-363 HTP Replacement Model 2",
"11|83-369 HTP Replacement",
"12|83-381 HTP Flex",
"13|83-381 HTP Replacement",
"14|83-390 HTP Replacement");//NAPA - MIG

var ModelArray33 = new Array("1|70 117-060 HTP Flex",
"2|70 117-060 HTP Replacement",
"3|70 117-060 OEM",
"4|83100 117-061 HTP Flex",
"5|83100 117-061 HTP Replacement",
"6|83100 117-061 OEM",
"7|83101 117-064 HTP Flex",
"8|83101 117-064 HTP Replacement",
"9|83101 117-064 OEM");//PowerMate - MIG

var ModelArray34 = new Array("1|PR-155 Model 1 HTP Replacement",
"2|PR-155 Model 2",
"3|PR-205MV HTP Replacement",
"4|SP-1 HTP Replacement",
"5|SP-2 HTP Replacement Model 1",
"6|SP-2 HTP Replacement Model 2",
"7|SP-5 HTP Replacement Model 1",
"8|SP-5 HTP Replacement Model 2",
"9|SP-5 3 HTP Replacement Model 1",
"10|SP-5 3 HTP Replacement Model 2");//Pro Spot - MIG

var ModelArray35 = new Array("1|180 Turbo MIG HTP Replacement",
"2|90201 HTP Replacement",
"3|93100 HTP Replacement Model 1",
"4|93100 HTP Replacement Model 2",
"5|93140 HTP Replacement Model 1",
"6|93140 HTP Replacement Model 2",
"7|93180 HTP Replacement",
"8|93300 HTP Replacement",
"9|E-Z Flux 90775 HTP Replacement Model 1",
"10|E-Z Flux 90775 HTP Replacement Model 2",
"11|Pro 140 HTP Replacement Model 1",
"12|Pro 140 HTP Replacement Model 2");//Schumacher Electric - MIG

var ModelArray36 = new Array("1|117-007 HTP Flex",
"2|117-007 HTP Replacement",
"3|117-007 OEM",
"4|MIG 160 117-009 HTP Replacement",
"5|MIG 160 117-009 OEM");//SD Lee - MIG

 var ModelArray37 = new Array("1|90070 HTP Replacement Model 1",
"2|90070 HTP Replacement Model 2",
"3|90071 HTP Replacement Model 1",
"4|90071 HTP Replacement Model 2",
"5|90085 HTP Replacement Model 1",
"6|90085 HTP Replacement Model 2",
"7|90131 OEM",
"8|90430 HTP Replacement",
"9|90440 HTP Replacement Model 1",
"10|90440 HTP Replacement Model 2");//Silver Beauty - MIG

 var ModelArray38 = new Array("1|196 Autoplus Turbo HTP Replacement");//SIP - MIG
 
var ModelArray39 = new Array("1|FM140A HTP Flex",
"2|FM140A HTP Replacement",
"3|FM140A OEM",
"4|MIG 115 HTP Replacement",
"5|MIG 120 HTP Replacement Model 1",
"6|MIG 120 HTP Replacement Model 2",
"7|MIG 125 HTP Replacement",
"8|MIG 135 HTP Replacement",
"9|MIG 160I HTP Flex",
"10|MIG 160I HTP Replacement",
"11|MIG 160I OEM",
"12|MIG 220 HTP Flex",
"13|MIG 220 HTP Replacement",
"14|MIG 220 OEM",
"15|MM120SL HTP Flex",
"16|MM120SL HTP Replacement",
"17|MM120SL OEM",
"18|MM140SL HTP Flex",
"19|MM140SL HTP Replacement",
"20|MM140SL OEM",
"21|MM250SL HTP Flex",
"22|MM250SL HTP Replacement",
"23|MM250SL OEM",
"24|MW120 HTP Flex",
"25|MW120 HTP Replacement",
"26|MW120 OEM",
"27|YA204 HTP Flex",
"28|YA204 HTP Replacement",
"29|YA204 OEM",
"30|YA204A HTP Flex",
"31|YA204A HTP Replacement",
"32|YA204A OEM",
"33|YA205 117-012 HTP Flex",
"34|YA205 117-012 HTP Replacement",
"35|YA205 117-012 OEM",
"36|YA205A 117-031 HTP Flex",
"37|YA205A 117-031 HTP Replacement",
"38|YA205A 117-031 OEM",
"39|YA205B 117-056 HTP Flex",
"40|YA205B 117-056 HTP Replacement",
"41|YA205B 117-056 OEM",
"42|YA212A HTP Flex",
"43|YA212A HTP Replacement",
"44|YA212A OEM",
"45|YA217 117-029 HTP Flex",
"46|YA217 117-029 HTP Replacement",
"47|YA217 117-029 OEM",
"48|YA217A 117-058 HTP Flex",
"49|YA217A 117-058 HTP Replacement",
"50|YA217A 117-058 OEM",
"51|YA219 117-022 HTP Flex",
"52|YA219 117-022 HTP Replacement",
"53|YA219 117-022 OEM",
"54|YA219A HTP Flex",
"55|YA219A HTP Replacement",
"56|YA219A OEM",
"57|YA219B 117-040 HTP Flex",
"58|YA219B 117-040 HTP Replacement",
"59|YA219B 117-040 OEM",
"60|YA219C 117-059 HTP Flex",
"61|YA219C 117-059 HTP Replacement",
"62|YA219C 117-059 OEM",);//Snap-on - MIG

var ModelArray40 = new Array("1|2110 117-033 HTP Flex",
"2|2110 117-033 HTP Replacment",
"3|2110 117-033 OEM",
"4|2114 117-045 HTP Flex",
"5|2114 117-045 HTP Replacment",
"6|2114 117-045 OEM",
"7|2115 117-026 HTP Flex",
"8|2115 117-026 HTP Replacment",
"9|2115 117-026 OEM",
"10|2120 117-020 HTP Flex",
"11|2120 117-020 HTP Replacment",
"12|2120 117-020 OEM",
"13|2120 117-043 HTP Flex",
"14|2120 117-043 HTP Replacment",
"15|2120 117-043 OEM",
"16|2125 117-010 HTP Flex",
"17|2125 117-010 HTP Replacment",
"18|2125 117-010 OEM",
"19|2130 117-050 HTP Flex",
"20|2130 117-050 HTP Replacment",
"21|2130 117-050 OEM",
"22|2140 117-053 HTP Flex",
"23|2140 117-053 HTP Replacment",
"24|2140 117-053 OEM",
"25|2145 HTP Replacement Model 1",
"26|2145 HTP Replacement Model 2",
"27|2150 117-051 HTP Flex",
"28|2150 117-051 HTP Replacment",
"29|2150 117-051 OEM",
"30|2155 HTP Replacement Model 1",
"31|2155 HTP Replacement Model 2",
"32|2160 117-067 HTP Flex",
"33|2160 117-067 HTP Replacment",
"34|2160 117-067 OEM",
"35|2165 117-003 HTP Replacement",
"36|2171 HTP Replacement Model 1",
"37|2171 HTP Replacement Model 2",
"38|2172 HTP Replacement Model 1",
"39|2172 HTP Replacement Model 2",
"40|2175 117-011 HTP Flex",
"41|2175 117-011 HTP Replacment",
"42|2175 117-011 OEM",
"43|2175 117-039 HTP Flex",
"44|2175 117-039 HTP Replacment",
"45|2175 117-039 OEM",
"46|2185 HTP Replacement Model 1",
"47|2185 HTP Replacement Model 2",
"48|2225 117-023 HTP Replacement",
"49|2225 117-023 OEM",
"50|2225 117-035 HTP Replacement",
"51|2225 117-035 OEM");//Solar - MIG

var ModelArray41 = new Array("1|MP140 HTP Flex",
"2|MP140 HTP Replacement",
"3|MP140 OEM",
"4|MP175 HTP Flex",
"5|MP175 HTP Replacement",
"6|MP175 OEM",
"7|MP250 HTP Flex",
"8|MP250 HTP Replacement",
"9|MP250 OEM",
"10|PBE140 HTP Flex",
"11|PBE140 HTP Replacement",
"12|PBE140 OEM",
"13|PBE180 HTP Flex",
"14|PBE180 HTP Replacement",
"15|PBE180 OEM",
"16|PBE250 HTP Flex",
"17|PBE250 HTP Replacement",
"18|PBE250 OEM");//Systematics - MIG

 var ModelArray42 = new Array("1|Fabricator 181i HTP Flex",
"2|Fabricator 181i HTP Replacement",
"3|Fabricator 211i HTP Flex",
"4|Fabricator 211i HTP Replacement",);//Thermal Arc - MIG

 var ModelArray43 = new Array("1|Fabricator 181i HTP Flex",
"2|Fabricator 181i HTP Replacement",
"3|Fabricator 211i HTP Flex",
"4|Fabricator 211i HTP Replacement",);//Tweco - MIG

var ModelArray44 = new Array("1|MIGMax 215 HTP Flex",
"2|MIGMax 215 HTP Replacement",
"3|OmniPro 220 HTP Flex",
"4|OmniPro 220 HTP Replacement",);//Vulcan - MIG

var ModelArray45 = new Array("1|MIG 140 HTP Flex",
"2|MIG 140 HTP Replacement",
"3|MIG 140 OEM");//Weldmart Models - MIG// JavaScript Document


//* Type Test
var TypeArray1 = new Array("Air-Cooled",
"Water-Cooled");//Type Test
var TypeArray2 = new Array("Air-Cooled",
"Water-Cooled");//Type Test
var TypeArray3 = new Array("Air-Cooled",
"Water-Cooled");//Type Test
var TypeArray4 = new Array("Air-Cooled",
"Water-Cooled");//Type Test
var TypeArray5 = new Array("Air-Cooled",
"Water-Cooled");//Type Test
var TypeArray6 = new Array("Air-Cooled",
"Water-Cooled");//Type Test
var TypeArray7 = new Array("Air-Cooled",
"Water-Cooled");//Type Test
var TypeArray8 = new Array("Air-Cooled",
"Water-Cooled");//Type Test
var TypeArray9 = new Array("Air-Cooled",
"Water-Cooled");//Type Test
var TypeArray10 = new Array("Air-Cooled",
"Water-Cooled");//Type Test
var TypeArray11 = new Array("Air-Cooled",
"Water-Cooled");//Type Test
var TypeArray12 = new Array("Air-Cooled",
"Water-Cooled");//Type Test
var TypeArray13 = new Array("Air-Cooled",
"Water-Cooled");//Type Test




function loadBrand()
{
	var selectBrand = document.getElementById("selectBrand");

	if (selectBrand != null && BrandArray != null)
	{
		loadOptions(selectBrand, BrandArray, "- Brand -");	
	}	
}

function loadOptions(select, list, initOption)
{
	if (select != null && list != null)
	{
		select.options.length = 0;
		select.options[select.options.length] = new Option(initOption, "-1");
		for (i = 0; i < list.length; i++)
		{
			var opt = list[i].split("|");
			select.options[select.options.length] = new Option(opt[1], opt[0]);
		}
	}
}

function loadJoes(select, list, initOption)
{
	if (select != null && list != null)
	{
		select.options.length = 0;
		select.options[select.options.length] = new Option(initOption, "-1");
		for (i = 0; i < list.length; i++)
		{
			var opt = list[i];
			select.options[select.options.length] = new Option(opt, opt);
		}
	}
}

function resetSelect(select)
{
	var btnSearch = document.getElementById("btnSearch");

	select.options[0].selected = true;
	select.disabled = true;
	btnSearch.disabled = true;
}

function changeBrand()
{
	var selectBrand = document.getElementById("selectBrand");
	var selectModel = document.getElementById("selectModel");
	var selectJoe = document.getElementById("selectJoe");

		
	if (selectBrand != null)
	{
		if (selectBrand.value != "-1")
		{
			if (selectModel != null)
			{
				loadOptions(selectModel, eval("ModelArray" + selectBrand.value), "- Model -");
				selectModel.disabled = false;
				resetSelect(selectJoe);

			}		
		}
		else
		{
			resetSelect(selectModel);	
			resetSelect(selectJoe);

		}
	}
}

function changeModel()
{
	var selectModel = document.getElementById("selectModel");
	//*var selectJoe = document.getElementById("selectJoe");
	var override = false;

	if (selectModel != null)
	{
		if (selectJoe != null)
		{
			if (selectModel.value != "-1")
			{
				try
				{
					eval("JoeArray" + selectModel.value);
					override = true;
				}
				catch(err)
				{
					override = false;
				}
			
				if (override)
				{
					loadJoes(selectJoe, eval("JoeArray" + selectModel.value), "- Joe -");

				}
				else
				{
					loadJoes(selectJoe, JoeArrayDefault, "- Joe -");

				}
				selectJoe.disabled = false;
			}
			else
			{
				resetSelect(selectJoe);

			}
		}
	}
	else
	{
		resetSelect(selectJoe);
	}
}

function changeJoe()
{
	var selectJoe = document.getElementById("selectJoe");
	var btnSearch = document.getElementById("btnSearch");
	var override = false;

	if (selectJoe != null)
	{
		if (selectJoe.value != "-1")
		{

			btnSearch.disabled = false;
		}
		else
		{

			btnSearch.disabled = false;
		}
	}
}

function performSearch()
{
	var selectBrand = document.getElementById("selectBrand");
	var selectModel = document.getElementById("selectModel");
	//*var selectJoe = document.getElementById("selectJoe");

	
	if (selectModel != null)
	{
		//*var mod = selectJoe.options[selectJoe.selectedIndex].text;
var Brand = selectBrand.options[selectBrand.selectedIndex].text.replace(' ', '_' ).split(' ').join('_');

var Model = selectModel.options[selectModel.selectedIndex].text.replace(' ', '_' ).split(' ').join('_');
      
		var url = "https://usaweld.com/collections/";
	
        url += Brand + "_" + Model;

		doSearch(url); 		
	}
}

function doSearch(url)
{
		top.location.href = url; 
}// JavaScript Document// JavaScript Document